import { teamPitchEventsAtom, teamUnwrappedPitchEventsAtom } from '@/atoms/vis/teamVis';
import { MetricKeyFallbackWrapper } from '@/components/metric/MetricKeyFallbackWrapper';
import { EventMap } from '@/components/visualisations/EventMap';
import { PitchVisComponentProps } from '@/types/visualisation';

export const TeamEventMap = ({ allowInteraction, isPreview }: PitchVisComponentProps) => (
  <MetricKeyFallbackWrapper>
    <EventMap
      allowInteraction={allowInteraction}
      pitchEventsAtom={teamPitchEventsAtom}
      unwrappedPitchEventsAtom={teamUnwrappedPitchEventsAtom}
      isPreview={isPreview}
      swapCropUnderAgainst
    />
  </MetricKeyFallbackWrapper>
);
